import React from 'react';
import PropTypes from 'prop-types';
import Helmet from 'react-helmet';
import favicon from './assets/img/comdeslezards_favicon.png';
import Menu from '../components/Menu';
import './index.css';

function trackEvent(category, action) {
  window.ga('send', 'event', {
    eventCategory: category,
    eventAction: action
  });
}

function trackChatOpen() {
  trackEvent('Chat', 'open');
}

function trackChatSent() {
  trackEvent('Chat', 'sent');
}

class Layout extends React.Component {

  componentDidMount() {
    window.$crisp.push(["safe", true])
    window
      .$crisp
      .push(['on', 'chat:opened', trackChatOpen]);
    window
      .$crisp
      .push(['on', 'message:sent', trackChatSent]);
  }

  render() {
    const {children, data} = this.props;
    return (
      <div>
        <Menu/>
        <Helmet
          title={data.site.siteMetadata.title}
          >
          <html lang="fr" />
          <link rel="icon" type="image/png" href={favicon}/>
        </Helmet>
        <div style={{}}>
          {children()}
        </div>

      </div>
    );
  };
}
Layout.propTypes = {
  children: PropTypes.func.isRequired,
};

export default Layout;

export const query = graphql `
  query SiteTitleQuery {
    site {
      siteMetadata {
        title
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/layouts/index.jsx